import React, { Component } from 'react';
import { connect } from 'react-redux';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Modal from 'react-responsive-modal';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';

const log = new Logger('SAVE_FILING_TO_WORKFLOW', LOG_LEVELS.DEBUG);
const MODAL_CLASSNAMES = {
  modal: 'modal-full-width',
};
const radioStyle = {
  width: 'auto',
  position: 'relative',
};

const regularSubmission = 'regular';
const correctiveSubmission = 'corrective';

export class SaveFilingToWorkflow extends Component {
  constructor(props) {
    super(props);
    this.state = Object.assign({}, this.state, {
      isWorkflowModalOpen: false,
      submissionType: regularSubmission,
    });
  }

  openWorkflowModal = () => {
    log.clearAllDictionaryErrors();
    this.setState({ isWorkflowModalOpen: true });
  };

  closeWorkflowModal = () => {
    this.setState({ isWorkflowModalOpen: false });
  };

  onButtonClick() {
    this.closeWorkflowModal();
    this.props.onSaveToWorkflow(this.state.submissionType, this.props.filingTypeFlow, this.props.isFileVatBookPreviewPdf);
  }

  onChangeSubmissionType(event) {
    this.setState({
      submissionType: event.currentTarget.value,
    });
  }

  render() {
    log.debug('render(): ', this.props);

    const radios = (
      <div>
        <fieldset role="radiogroup" aria-labelledby="label2">
          <legend id="label2">
            <LanguageStringResolver string="saveToWorkflow_returnTypeConfirmation" />
          </legend>
          <input
            type="radio"
            id="rbRegular"
            name="returnTypeConfirmation"
            value={regularSubmission}
            onChange={this.onChangeSubmissionType.bind(this)}
            checked={this.state.submissionType === regularSubmission}
          />
          <label className="radio" htmlFor="rbRegular" style={radioStyle}>
            Regular
          </label>
          <input
            type="radio"
            id="rbCorrective"
            name="returnTypeConfirmation"
            value={correctiveSubmission}
            onChange={this.onChangeSubmissionType.bind(this)}
            checked={this.state.submissionType !== regularSubmission}
          />
          <label className="radio" htmlFor="rbCorrective" style={radioStyle}>
            Corrective
          </label>
        </fieldset>
      </div>
    );
    return (
      <ReadOnlyWrapper>
        <button 
          data-test="btn-save-to-workflow" 
          className="secondary margin-bottom-md"
          onClick={this.openWorkflowModal.bind(this)}
        >
          <LanguageStringResolver string={`${this.props.isFileVatBookPreviewPdf ? 'filingPage_SavePdfPreviewToWorkflow' : 'filingPage_SaveToWorkflowBtn'}`} />
        </button>
        <Modal center classNames={MODAL_CLASSNAMES} open={this.state.isWorkflowModalOpen} onClose={this.closeWorkflowModal}>
          <div>
            <h1>
              <LanguageStringResolver string="confirmationModal_TitleSaveToWorkflow" />
            </h1>
            {radios}
            <p className="margin-bottom-md bold">
              <LanguageStringResolver string="saveToWorkflow_confirmation" />
            </p>

            <a className="button primary" onClick={this.onButtonClick.bind(this)}>
              <LanguageStringResolver string="submitFiling_ok" />
            </a>
            <a className="button secondary" onClick={this.closeWorkflowModal.bind(this)}>
              <LanguageStringResolver string="submitFiling_cancel" />
            </a>
          </div>
        </Modal>
      </ReadOnlyWrapper>
    );
  }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
  return {};
}


SaveFilingToWorkflow.defaultProps = {
  isFileVatBookPreviewPdf: false
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(SaveFilingToWorkflow);
